import script from "./ClientCabinetDocumentCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientCabinetDocumentCard.vue?vue&type=script&setup=true&lang=js"

import "./ClientCabinetDocumentCard.vue?vue&type=style&index=0&id=fb92eafc&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb92eafc"]])

export default __exports__